// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d98572a2","453":"8eb2efb3"}[chunkId] + ".chunk.js";
};